function layout() {
  const ctxView = {
    model: "hotel.operation_forecast",
    reportName: "hotel.operation_forecast.report",
    description: "Operation Forecast",
    fields: {
      operation_center: {
        type: "many2one",
        model: "company.operation_center",
        required: true,
      },
      fiscalyear: {
        type: "many2one",
        model: "account.fiscalyear",
      },
      period: {
        type: "many2one",
        model: "account.period",
        required: true,
      },
    },
    list: [],
    form: [
      { name: "fiscalyear" },
      { name: "operation_center" },
      { name: "period" },
    ],
  };
  return ctxView;
}
export { layout };
